import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoDropdownComponent } from 'ngx-eo-web-components';
import { HospitalService } from '../../../../services/hospital/hospital.service';
import { STATUS } from '../../../core/models/loading-status.enum';
import { Hospital } from '../../../core/models/hospital.model';

@Component({
  selector: 'app-hospital-dropdown',
  templateUrl: './hospital-dropdown.component.html',
  styleUrl: './hospital-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HospitalDropdownComponent),
      multi: true,
    },
  ],
})
export class HospitalDropdownComponent extends EoDropdownComponent<Hospital> {
  @Input() override label = 'Νοσοκομείο';
  @Input() override optionLabel = 'hospitalName';
  @Input() override optionValue = 'id';
  @Input() override placeholder = 'Όλα τα νοσοκομεία';
  @Input() override filterPlaceholder = 'Αναζήτηση με όνομα';
  @Input() override filterBy = 'hospitalName';
  override options: Hospital[] = [];
  hospitalListCallHandler = this.hospitalService.hospitalListCallHandler;

  constructor(private readonly hospitalService: HospitalService) {
    super();
  }

  override ngOnInit() {
    this.hospitalService.ensureHospitalDataLoaded().subscribe((data) => (this.options = data ?? []));
  }

  override hasFilter(): boolean {
    return true;
  }

  override isLoading(): boolean {
    return this.hospitalListCallHandler.status$.getValue() === STATUS.loading;
  }
}
